import { Pipe, PipeTransform } from '@angular/core';
import { InvoicingSummary, InvoiceStatus, CurrencyFormatter } from '@jms/model';
import * as Enumerable from 'linq';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'totalInvoicing',
  standalone: true
})
export class TotalInvoicingPipe implements PipeTransform {

  constructor() { }

  transform(invoices: any[], ...args: unknown[]): string {

    let total = Enumerable
      .from(invoices)
      .where(x => x.status !== InvoiceStatus.Void)
      .sum(x => x.subTotal);

    if (total == null) {
      total = 0;
    }

    return CurrencyFormatter.formatCurrency(total, 2);
  }

}
